import { IonText } from "@ionic/react";
import { FormattedMessage } from "react-intl";

import styles from "@components/MedicationDescription.module.css";
type Props = {
  description: string;
  labelKey: string;
};

const MedicationDescription = ({ description, labelKey }: Props) => (
  <div className={styles.information}>
    <IonText className={styles.label}>
      <FormattedMessage id={labelKey} />
    </IonText>
    <IonText className={styles.description}>{description}</IonText>
  </div>
);
export default MedicationDescription;
